import ReservationImage from "./ReservationImage";

export default class Reservation {
  constructor() {
    this.id = null;
    this.checkinDate = "";
    this.checkoutDate = "";
    this.companyId = null;
    this.companyName = "";
    this.reservationNumber = "";
    this.guests = [];
    this.image = new ReservationImage();
  }
}
